import styled from 'styled-components';
import AggregatedLoadRow from './AggregatedLoadRow';

export default styled(AggregatedLoadRow)`
  width: 100%;
  background: var(--white);
  padding: 0.8rem 1.6rem;
  border-bottom: 1px solid var(--grey300);

  /* .stop-load {
    width: 200px;
    padding-left: 24px;
    margin-bottom: 0.8rem;
    &__weight {
      color: var(--grey700);
    }
  } */

  .bold-load {
    font-weight: bold;
    .stop-load__weight {
      color: var(--grey900);
    }
  }
`;
